exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#myadd {\n  margin: 10px;\n}\n#position-box{\n  position: relative;\n}\n#deviceTypeCode{\n  position: fixed;\n  top: 100px;\n  right: 10px;\n  width: 200px;\n  z-index: 999;\n}\n", ""]);

// exports
